module.exports = __webpack_public_path__ + "img/ico-assigned-activities.9df276e2.svg";